import React, { useEffect, useState, useContext } from "react";
import { Button, Row, Col, Form, Checkbox, Select, message } from 'antd';
import Iedit from './../../../../src/assets/pvi-benhhiemngheo/iedit.svg';
import Iadd from './../../../../src/assets/pvi-benhhiemngheo/iadd.svg';
import Idelete from './../../../../src/assets/pvi-benhhiemngheo/idelete.svg';
import { AuthContext } from './../index';
import Helper from "./../../../extra/helper";
import Mdelete from './../modalnotification/modalwaringdelete';
import MdRene from "./../modalnotification/modalConfirmRenewals";
import MdAddPeson from "./../modalnotification/modalAddPeson";
import Service from "./../../../extra/getAPI";
import moment from "moment";

export default function AddAndEditBuyer() {
  const { listIsu, goStep, ActionList, dataRenewals, CheckRenewals, Back, toltalFees } = useContext(AuthContext);
  const { Option } = Select;
  const [packages, setPackages] = useState(null);
  const [action, setAction] = useState(null);
  const [index, setIndex] = useState(null);
  const [formData, setFormData] = useState(null);
  const [openModalDelete, setOpenModalDelete] = useState(0);
  const [err, setErr] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [isModalVisibleRene, setIsModalVisibleRene] = useState(false);
  const [listErrDate, setListErrDate] = useState([]);
  const [dataBuyer, setDataBuyer] = useState({});


  useEffect(() => {
    window.scrollTo(0, 0);
    let dataIsu2 = JSON.parse(localStorage.getItem('dataIsu'));
    if (dataIsu2) {
      form.setFieldsValue({ "buyfor": [dataIsu2.buyfor] });
      setFormData(dataIsu2);
      // CheckRenewals(dataIsu2.insuredDob, dataIsu2.insuredPrivateId);
      if (listIsu) {
        if (dataIsu2?.buyfor === 2 && listIsu[0]?.relationshipWithBuyerId === 1) {
          ActionList('delete', 0, '');
        }
      }
    }
  }, []);

  //Nêu mua cho người thân thì hiện modal thêm người
  useEffect(() => {
    let dataIsu2 = JSON.parse(localStorage.getItem('dataIsu'));
    if (dataIsu2 && listIsu?.length === 0) {
      if (dataIsu2.buyfor === 2) {
        showModal('add');
      }
    }
  }, []);

  const actionForm = (val) => {
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    form
      .validateFields()
      .then(async (values) => {
        if (listIsu.length > 0) {
          verifyDate();
          // goStep(6);
        } else {
          showModal('add');
          message.error({
            content: 'Vui lòng thêm người được bảo hiểm!',
            style: {
              marginTop: '2vh',
            },
          }, 10);
        }
      })
      .catch((err) => {
        // console.error('err:', err);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCancelRene = () => {
    setIsModalVisibleRene(false);
  };

  const AddBuyer = (e) => {
    if (e[0] === 1) {
      let databuyer = JSON.parse(localStorage.getItem('databuyer'));
      setDataBuyer(databuyer);
      setTimeout(() => {
        addBuyerTolist();

        // if (dataRenewals.statusCode === 200 && dataRenewals?.result?.renewals === 0) {
        //   if (databuyer) {
        //     addBuyerTolist();
        //   }
        // } else if (dataRenewals.statusCode === 200 && dataRenewals?.result?.renewals === 1) {
        //   setIsModalVisibleRene(true);
        // } else if (dataRenewals.statusCode === 400) {
        //   form.setFieldsValue({ "buyfor": [2] });
        //   message.warning({
        //     content: 'Tuổi của bạn không phù hợp nếu là người được bảo hiểm!',
        //     style: {
        //       marginTop: '10vh',
        //     },
        //   }, 10);
        // }
      }, 100);
    } else {
      let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
      if (listIsu && listIsu[0]?.relationshipWithBuyerId === 1) {
        ActionList('delete', 0, '');
        setTimeout(() => {
          localStorage.setItem('dataIsu',
            JSON.stringify({
              ...dataIsu,
              buyfor: 2
            })
          )
        }, 100);
      }
    }
  };

  const ConfirmRene = (key) => {
    setIsModalVisibleRene(!isModalVisibleRene);
    if (key === 'yes') {
      addBuyerTolist();
    }
  }


  const addBuyerTolist = (item) => {
    let databuyer = JSON.parse(localStorage.getItem('databuyer'));
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    ActionList('unshift', '', databuyer);
    setTimeout(() => {
      localStorage.setItem('dataIsu',
        JSON.stringify({
          ...dataIsu,
          buyfor: 1
        })
      );
    }, 100);
  }

  // Ẩn hiện modal thêm và edit người
  const showModal = (key, index) => {
    // key là add hoặc edit
    setAction(key);
    setIndex(index);
    setIsModalVisible(true);
  };


  const OpenModalDelete = (action, index) => {
    setOpenModalDelete(action);
    if (action == 2) {
      ActionList('delete', +index, '')
      setOpenModalDelete(0);
    }
  }

  const Delete = (index) => {
    if (listIsu) {
      ActionList('delete', +index, '');
    }
  }

  const verifyDate = async () => {
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    let listInsured = JSON.parse(localStorage?.getItem('listInsured'));
    if (listInsured?.length > 0) {
      const mappedArray = listInsured?.map(({ insuredDob, insuredGender, insuredPrivateId }) => ({
        insuredDob: moment(insuredDob, "DD/MM/YYYY").format("YYYY-MM-DD"),
        insuredGender: +insuredGender,
        insuredPrivateId: insuredPrivateId
      }));
      // console.log('mappedArray',mappedArray);
      // return
      const param = {
        validFrom: moment(dataIsu?.beginDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
        listOfInsuredPeople: mappedArray
      };
      Service.apicall(
        "POST",
        `/v1/products/critical-disease/effective-date/verify`, param
      )
        .then((res) => {
          if (res.data.success) {
            goStep(6);
          }
        })
        .catch((err) => {
          // console.log('dataErr',err?.response?.data?.data);
          if (err?.response) {
            setListErrDate(err?.response?.data?.data);
            message.error(`Ngày hiệu lực không hợp lệ, Vui lòng kiểm tra lại thông tin!`);
          }
          // if (err.response) {
          //   message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
          // }
        });
    }
  }


  const css = {
    input: { color: '#3A3A3A', zIndex: 1, fontSize: 15, boxShadow: 'none', padding: '7px 35px', borderRadius: 9, width: '100%' },
    titleInput: { color: '#646D69', marginBottom: 3 },
    FormItemsHolder: { width: "100%", borderRadius: 8, margin: '5px 0px', padding: 0 },
    iconInput: { width: 20, margin: '12px 10px', position: 'absolute', zIndex: 2 }
  }

  return (
    <div style={{ fontSize: 14 }}>
      {
        isModalVisibleRene &&
        <MdRene ConfirmRene={ConfirmRene} handleCancel={handleCancelRene} isModalVisible={isModalVisibleRene} />
      }
      {openModalDelete > 0 &&
        <Mdelete dataRemove={listIsu} openModalDelete={OpenModalDelete} />
      }
      {
        isModalVisible &&
        <MdAddPeson index={index} action={action} handleCancel={handleCancel} isModalVisible={isModalVisible} />
      }
      <Form
        ref={formRef}
        form={form}
        onFinish={actionForm}
        name="Serach_account"
      >
        <Row>
          <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontWeight: 600, padding: '2% 3%', width: 500}}>Thông tin gói bảo hiểm</div>
            <img onClick={() => goStep(3)} style={{ width: 16, marginRight: '3%' }} src={Iedit} alt="edit icon" />
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '100px' }}>Gói bảo hiểm</div>
            <div style={{ fontWeight: 500, textAlign: 'right' }}>
              Chương trình BH {formData?.packedIndex} - {formData?.listPackageInsu[formData?.packedIndex - 1]?.benefit}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Thời hạn bảo hiểm</div>
            <div style={{ fontWeight: 500 }}>
              {formData?.beginDate + ' - ' + formData?.endDate}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '10px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Số năm bảo hiểm</div>
            <div style={{ fontWeight: 500 }}>
              {formData?.yearsOfInsurance} năm
            </div>
          </Col>
          <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontWeight: 600, padding: '2% 3%', width: 230}}>Thông tin người mua bảo hiểm</div>
            <img onClick={() => goStep(4)} style={{ width: 16, marginRight: '3%' }} src={Iedit} alt="edit icon" />
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Họ và tên</div>
            <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
              {formData?.insuredName}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Ngày sinh</div>
            <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
              {formData?.insuredDob}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Giới tính</div>
            <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
              {formData?.insuredGender === 1 ? 'Nam' : 'Nữ'}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '150px' }}>Số điện thoại</div>
            <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
              {formData?.buyerPhone}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '180px' }}>CMND/ CCCD/ Hộ chiếu</div>
            <div style={{ fontWeight: 500, textTransform: 'capitalize' }}>
              {formData?.insuredPrivateId}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '180px' }}>Email</div>
            <div style={{ fontWeight: 500 }}>
              {formData?.buyerEmail}
            </div>
          </Col>
          <Col style={{ padding: '2% 3%', borderBottom: '10px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }} xs={24}>
            <div style={{ fontsize: 12, color: '#9A9A9A', width: '100px' }}>Địa chỉ</div>
            <div style={{ fontWeight: 500, textAlign: 'right', textTransform: 'capitalize' }}>
              {formData?.buyerAddress ? formData?.buyerAddress : 'N/A'}
            </div>
          </Col>
          <Col style={{ borderBottom: '1px solid #828EE1', background: '#ffffff' }} xs={24}>
            <div style={{ fontWeight: 600, padding: '2% 3%', width: 300}}>Danh sách người được bảo hiểm</div>
          </Col>

          <Col style={{ padding: '0px 3%', background: '#ffffff' }} xs={24}>
            <Form.Item
              name="buyfor"
              rules={[{
                required: false,
                message: 'Vui lòng chọn và nhập thông tin'
              }]}
              style={css.FormItemsHolder}
            >
              <Checkbox.Group
                onChange={(e) => {
                  AddBuyer(e);
                }}
                style={{ width: '100%' }}>
                <Checkbox value={1}>Chọn mua cho bản thân</Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </Col>
          {(listIsu || []).map((data, index) => (
            <Col key={index} style={{ padding: '2% 3%', marginBottom: (index + 1) === listIsu.length ? 30 : 0, borderBottom: '1px solid #EDEFFA', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
              {/* <p>
                <p style={{ fontWeight: 600, textTransform: 'capitalize' }}>{data.insuredName}</p>
                <p style={{
                  color: 'red', fontSize: 12, display: listErrDate.filter(
                    (item) => item.insuredPrivateId === data?.insuredPrivateId
                  ).length === 1 ? '' : 'none'
                }}>Hiệu lực không đúng. Vui lòng chọn lại ngày hiệu lực là <div style={{ color: 'green' }}>
                    {
                      moment(listErrDate.filter(
                        (item) => item.insuredPrivateId === data?.insuredPrivateId
                      )?.[0]?.validFrom, "YYYY-MM-DD").format("DD/MM/YYYY")
                    }
                  </div>
                </p>
                <p style={{ fontSize: 12, color: '#9A9A9A' }}>{Helper._render_quan_he(data.relationshipWithBuyerId)}</p>
              </p> */}
              <div>
                <div style={{ fontWeight: 600, textTransform: 'capitalize' }}>{data.insuredName}</div>
                <div style={{ fontSize: 12, color: '#9A9A9A' }}>{Helper._render_quan_he(data.relationshipWithBuyerId)}</div>
                <div style={{ marginTop: 5 ,fontSize: 12,color: 'red', display: listErrDate?.filter(
                      (item) => item.insuredPrivateId === data?.insuredPrivateId
                    ).length === 1 ? '' : 'none'
                  }}>
                   Ngày hiệu lực không hợp lệ. Vui lòng chọn lại ngày hiệu lực <span style={{ color: 'green' }}>
                    {
                      moment(listErrDate.filter(
                        (item) => item.insuredPrivateId === data?.insuredPrivateId
                      )?.[0]?.validFrom, "YYYY-MM-DD").format("DD/MM/YYYY")
                    }
                  </span>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  onClick={() => {
                    data.relationshipWithBuyerId !== 1 ?
                      showModal('edit', +index) :
                      goStep(4);
                  }}
                  style={{ width: 18, marginRight: 15, display: data.relationshipWithBuyerId === 1 ? 'none' : 'flex' }}
                  src={Iedit} alt="edit icon" />
                <img onClick={() => {
                  Delete(index)
                }
                } style={{ width: 18, display: data.relationshipWithBuyerId === 1 ? 'none' : 'flex', }} src={Idelete} alt="delete icon" />
              </div>
            </Col>
          ))}

          <Col style={{ borderTop: '10px solid #EDEFFA', borderBottom: '1px solid #828EE1', background: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} xs={24}>
            <div style={{ padding: '2% 3%', fontWeight: 600, width: 400}}>
              Mua thêm cho người thân
            </div>
            <img onClick={() => showModal('add')} style={{ width: 18, marginRight: '3%' }} src={Iadd} alt="edit icon" />
          </Col>
          <div style={{ width: '100%', height: 10, background: '#EDEFFA', marginBottom: 150 }}></div>
          <Col xs={24}>
            <div style={{ borderRadius: '16px 16px 0px 0px', justifyContent: 'center', padding: '16px 18px 20px 18px', boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.1)', position: 'fixed', bottom: 0, width: '100%', background: '#ffffff', maxWidth: 800 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                <div>Tổng tiền thanh toán</div>
                <div>
                  <span style={{ fontWeight: 600, color: '#2A3790', fontSize: 18 }}>
                    {toltalFees || 0}
                  </span>
                  <span style={{ color: '#9A9A9A', fontSize: 14 }}> VNĐ</span>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button onClick={() => { Back() }} size="large" style={{ fontSize: 14, background: '#fff', color: '#2A3790', width: '48%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                  Quay lại
                </Button>
                <Button onClick={() => { actionForm() }} size="large" style={{ fontSize: 14, background: '#2A3790', color: '#ffffff', width: '48%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                  Tiếp tục
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    </div >
  );
};
